import PropTypes from "prop-types"
import React from 'react';
import { TouchableOpacity, View } from 'react-native';
import { getResponsiveStyle } from '../utils/appUtils';
import styles from './styles/style';
import Text from './customText';
const CustomBootbox = props => {
  const { measure } = props;
  const showModal = props.agebootbox || props.bootboxmodal;
  if (showModal) {
    return (
      <View
        style={[
          styles.bootboxcontainer,
          props.hideBlackout === undefined
            ? null
            : {
                backgroundColor: 'rgba(0, 0, 0, 0.9)',
                height: '100%',
                justifyContent: null,
              },
          styles[getResponsiveStyle('bootboxcontainer', measure)],
        ]}
      >
        <View
          style={[
            styles.bootboxMainbox,
            styles[getResponsiveStyle('bootboxMainbox', measure)],
          ]}
        >
          <View>
            <TouchableOpacity
              style={[
                styles.bootboxbtn,
                styles[getResponsiveStyle('bootboxbtn', measure)],
              ]}
              onPress={() => {
                props.closebootbox();
              }}
            >
              <Text
                style={[
                  styles.bootboxbtnText,
                  styles[getResponsiveStyle('bootboxbtnText', measure)],
                ]}
              >
                X
              </Text>
            </TouchableOpacity>
          </View>
          <View
            style={[
              styles.bootboxtextView,
              styles[getResponsiveStyle('bootboxtextView', measure)],
            ]}
          >
            <Text
              style={[
                styles.bootboxtext,
                styles[getResponsiveStyle('bootboxtext', measure)],
              ]}
            >
              {props.bootboxtext}
            </Text>
          </View>
          <View
            style={[
              styles.bootboxborderline,
              styles[getResponsiveStyle('bootboxborderline', measure)],
            ]}
          />
          <View
            style={[
              styles.bootboxtextView,
              styles[getResponsiveStyle('bootboxtextView', measure)],
            ]}
          >
            <TouchableOpacity
              onPress={() => {
                props.closebootbox();
              }}
              style={[
                styles.bootboxbtn2,
                styles[getResponsiveStyle('bootboxbtn2', measure)],
                { height: null, paddingVertical: 10 },
              ]}
            >
              <Text
                style={[
                  styles.bootboxtext1,
                  styles[getResponsiveStyle('bootboxtext1', measure)],
                ]}
              >
                OK
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    );
  } else {
    return <View></View>;
  }
};

CustomBootbox.propTypes = {
  agebootbox: PropTypes.any,
  bootboxmodal: PropTypes.any,
  bootboxtext: PropTypes.any,
  closebootbox: PropTypes.func,
  hideBlackout: PropTypes.any,
  measure: PropTypes.any
}

export default CustomBootbox;
